<div class="login-wrapper">
    <div class="login-box">
        <div class="logo">
            <img src="assets/Logo-Biotechsa.png" alt="BrightID" />
        </div>

        <h2>Sign in</h2>

        <form [formGroup]="formLogin" (ngSubmit)="login()">
            <div class="p-field">
                <label for="email">Correo Electronico</label>
                <input pInputText id="email" formControlName="email" placeholder="Enter your email"
                    class="p-inputtext-sm form-control" />
            </div>

            <div class="p-field">
                <label for="password">Contraseña</label>
                <input type="password" pPassword id="password" formControlName="password" [feedback]="false" />
            </div>

            <button pButton type="submit" label="Sign in" class="login-btn"></button>



            <div class="privacy-policy">
                <a href="#">Privacy policy</a>
            </div>
        </form>
    </div>
</div>